import { apiGet } from './client';

export interface StaticPage {
  name: string;
  path: string;
}

/** Lists the .html pages of a static sub-project. Used by the in-SPA viewer's sidebar. */
export function getStaticPages(slug: string): Promise<StaticPage[]> {
  return apiGet<StaticPage[]>(`/${encodeURIComponent(slug)}/_pages.json`);
}
